// react native に依存しない汎用モジュールのみ配置

/*
・immer の場合、_next を {} で直接上書いてはいけない模様
・await せずに promise を _o_end した場合、処理が終了しない場合がある（当然か）

・map 内部で list の要素を setState しない（特に clds の list）
　（map 中で immer を用いて要素ごとに setState とした場合、元の list を破壊し正しく動作しない模様）

*/

// for immer
import { enableMapSet } from "immer"
enableMapSet()
import produce from "immer"

import moment from "moment"

import LZString from 'lz-string'; // npm install --save lz-string

import utf8 from 'utf8'; // npm install --save utf8
import {decode as atob, encode as btoa} from 'base-64' // npm install base-64 --save


import Papa from 'papaparse'; // ファイル取込においてCSV形式へ変換する際に必要

//import FileSaver from 'file-saver';
//import CryptoJS from "crypto-js"

import Encoding from 'encoding-japanese' // ファイル取込においてファイル形式を判別する際に必要

String.prototype.f = function () { // format
  let _i = 0, _args = arguments;
  return this.replace(/{}/g, function () {
    return (typeof _args[_i] != undefined) ? ((bf.myCM_chk_type(_args[_i], 'dct') || bf.myCM_chk_type(_args[_i], 'list')) ? bf.s(_args[_i++]) : _args[_i++]) : '';
  });
};

String.prototype.f2 = function () { // dictionary 形式対応版
  let _str = this;
  let _l_keys = _str.match(/\{[0-9a-zA-Z_]{4,8}\}/g);
  if (_l_keys != null) {
    for (let [_idx, _fld] of bf.e(_l_keys)) {
      _fld = _fld.replace('{','').replace('}','');
      for(let _key in arguments){
        let _val = arguments[_key][_fld];
        if (_val == null || _val == undefined ){ // null または undefined の場合は 空白に置き換え
          _val = '';
        };
        _str = _str.replace('{'+_fld+'}', _val);
        break;
      };
    };
  };
  return _str;
};

export class bf { // base function
  ////////////////////////////////////////////////////////////////////////
  static dlm = '_';
  static minDtm = '0000-00-00 00:00:00'; // date time min
  static maxDtm = '9999-01-01 00:00:00'; // date time max

  ////////////////////////////////////////////////////////////////////////

  static b(pld_whenThen) { // branch
    for (let [_idx, _d_whenThen] of bf.e(pld_whenThen)) {
      if (_d_whenThen.b_when) {
        return _d_whenThen.o_then();
      }
      else if (_d_whenThen.o_else) {
        return _d_whenThen.o_else();
      }
    };
  };
/*
  static b(pld_whenThen) { // branch
    for (let [_idx, _d_whenThen] of bf.e(pld_whenThen)) {
      if (_d_whenThen.b_when) {
        return _d_whenThen.then || _d_whenThen.o_then();
      }
      else if (_d_whenThen.else) {
        return _d_whenThen.else;
      }
      else if (_d_whenThen.o_else) {
        return _d_whenThen.o_else();
      };
    };
  };
*/

  static c(pa_vals1, pa_vals2) { // concatenate list or dictionary
    if (bf.myCM_chk_type(pa_vals1, 'list')) {
      return pa_vals1.concat(pa_vals2);
    };
    if (bf.myCM_chk_type(pa_vals1, 'dct')) {
      return { ...pa_vals1, ...pa_vals2};
    };
  };

  static e(pa_vals) { // entries
    //
    if (!bf.f(pa_vals)) {
      return [];
    };
    //
    if (bf.myCM_chk_type(pa_vals, 'dct')) {
      return Object.entries(pa_vals)
    };
    if (bf.myCM_chk_type(pa_vals, 'list')) {
      return pa_vals.entries()
    };
  };

  static f(pa_val){ // check not blank (fulfilled)
    //
    if (pa_val == null) {
      return false;
    }
    else if (pa_val == undefined) {
      return false;
    }
    else {
      if (bf.myCM_chk_type(pa_val, 'dct')) {
        if (Object.keys(pa_val).length == 0) {
          return false;
        }
        else {
          return true;
        };
      }
      else if (bf.myCM_chk_type(pa_val, 'list')) {
        if (pa_val.length == 0) {
          return false;
        }
        else {
          return true;
        };
      }
      else {
        if (pa_val == NaN) {
          return false;
        }
        else if (pa_val == '') { // 0 も該当するもよう
          return false;
        }
        else if (pa_val == 'None') {
          return false;
        }
        else if (pa_val == 'null') {
          return false;
        }
        return true;
      };
    };
  };

  static i(pa_vals, pl_vals){ // check in
    if (bf.myCM_chk_type(pa_vals, 'dct')) {
      let _r = pl_vals;
      for (let [_key, _val] of bf.e(pa_vals)) {
        if (_r) {
          _r = _r.filter( _d_is => {
            return (_d_is[_key] == _val)
          });
        }
        else {
          break;
        }
      }
      if (bf.f(_r)) {
        return true;
      }
      else {
        return false;
      };
    }
    else {
      if (pl_vals.indexOf(pa_vals)>=0) {
        return true;
      }
      else {
        return false;
      };
    };
  };

  static j(p_str){ // from string to json
    if (bf.f(p_str)){
      return JSON.parse(p_str);
    }
    else {
      return null;
    };
  };

  static l(p_str) {
    let _l = new Error().stack;
    let _s = _l.split('at')[3];
    _s = _s.substr(0, _s.indexOf('('));
    _s = _s.substr(_s.indexOf('.')+1)
    console.log('({}) {} @ {}'.f(bf.myDT_get_now().substr(14, 5), p_str, _s));
  };

  static n(p_val) { // from string to number
    return (bf.f(p_val)) ? Number(p_val) : 0;
  };

  static s(pd_vals){ // from json to string
    return JSON.stringify(pd_vals);
  };

  static q(p_qry) { // query
    return p_qry.replace(/"/g, "'").replace(/\[/g, '"').replace(/\]/g, '"').replace(/;/g, '').replace(/IFNULL/g, 'COALESCE');
  };

  static p(pa_vals, po_fnc){ // produce, 同一の state の setState を重複させると正常に動作しない模様
    return produce(pa_vals, po_fnc);
  };


  //////////////////////////////////////////////////////////////////////// for common module
  static myCM_add_newKeyVal(pd_vals, pa_val) {
    let _newKey = bf.myCM_get_newKey(pd_vals);
    pd_vals[_newKey] = pa_val;
  };

  static myCM_chk_type(pa_val, p_type){
    //
    if (p_type == 'dct') {
      if (this.myCM_get_type(pa_val) == 'object'){
        return true;
      };
    }
    else if (p_type == 'list') {
      if (this.myCM_get_type(pa_val) == 'array'){
        return true;
      };
    }
    else if (p_type == 'nmb') {
      if (this.myCM_get_type(bf.n(pa_val)) == 'number'){
        return true;
      };
    }
    else if (p_type == 'str') {
      if (this.myCM_get_type(pa_val) == 'string'){
        return true;
      };
    };
    //
    return false;
  };

  static myCM_substr(p_srg, pn_byte) { // byte 指定の substr
      let _r = '';
      Array.from(pa_val).reduce( (_prev, _s) => {
        let _c = String(_s).charCodeAt(0)
        if ((_c >= 0x0 && _c < 0x81) || (_c === 0xf8f0) || (_c >= 0xff61 && _c < 0xffa0) || (_c >= 0xf8f1 && _c < 0xf8f4)) _prev += 1;
        _prev += 2;
        _r += (_prev <= pn_byte) ? _s : '';
      }, 0);
      return _r;
  };

  static myCM_cnv(p_mode, pa_val){ // async の場合に Base64 が正しく動作しない場合がある模様
    if (p_mode == 'str') { // from json to string
      return String(pa_val); // 数値の場合
    };

    if (p_mode == 'bytes') { // from string to json
      return Array.from(pa_val).reduce( (_prev, _s) => {
        let _c = String(_s).charCodeAt(0)
        if ((_c >= 0x0 && _c < 0x81) || (_c === 0xf8f0) || (_c >= 0xff61 && _c < 0xffa0) || (_c >= 0xf8f1 && _c < 0xf8f4)) return _prev + 1;
        return _prev + 2;
      }, 0);
    };

    if (p_mode == 'ceil') { // 切り捨て
      return Math.ceil(pa_val);
    };
    //
    if (p_mode == 'cmm' || p_mode == 'comma') { // カンマ区切り
      let _l = String(pa_val).replace(/,/g, '').split('.');
      let _r = String(_l[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      if (_l.length > 1) {
          _r += '.' + _l[1];
      }
      return _r;
    };

    if (p_mode == 'flr' || p_mode == 'floor') { // 切り捨て
      return Math.floor(pa_val);
    };

    if (p_mode == 'json') { // from string to json
      return JSON.parse(pa_val);
    };

    if (p_mode == 'list') { // from dictionary to list 
      return Object.entries(pa_val)
    };

    if (p_mode == 'nmb') { // from string to number 
      return parseFloat(pa_val)
    };

    if (p_mode == 'upr') { // upper 
      return String(pa_val).toUpperCase();
    };

    if (p_mode == 'lwr') { // lower 
      return String(pa_val).toLowerCase();
    };

    if (p_mode == 'cps') { // compress
      return LZString.compress(pa_val)
    };

    if (p_mode == 'dcs') { // decompress
      return LZString.decompress(pa_val)
    };

    if (p_mode == 'ecdBase64') { // encode uri
      if (bf.f(pa_val)) {
        return btoa(utf8.encode(pa_val));
      }
      else {
        return null;
      };
    };

    if (p_mode == 'dcdBase64') { // decode uri
      if (bf.f(pa_val)) {
        return utf8.decode(atob(pa_val));
      }
      else {
        return null;
      };
    };

    if (p_mode == 'str-ary') { // decode uri
      return bf.myCM_get_rng(pa_val.length).map( _i => {
        return pa_val.charCodeAt(_i - 1)
      })
    };

    alert('287: incorrect mode: {}'.f(p_mode))

  };

  static myCM_cnvCsvToJson = (p_csv) => new Promise( _o_end1 => {
    Papa.parse(p_csv, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      delimiter: ',',
//      transformHeader: h => h.trim(),
      transformHeader: h => h.replace(/\"/g, '').trim(),
      linebreak: '\n',
      complete: _d_rs => {
        _d_rs.ld_iss = _d_rs.data; // 命名規則を合わせるための言い換え
        _d_rs.data = null; // 命名規則を合わせるための言い換え
        _o_end1(_d_rs);
      },
    });
  });

  static myCM_get_cldDct(pd_dcts, p_pid, pn_lyrDff=0){ // get child dictionary
    let _l_keys = p_pid.split(bf.dlm);
    let _n_lyr = bf.myCM_get_len(_l_keys);
    let _d_dcts = pd_dcts;
    for (let [_n_idx, _key] of _l_keys.entries()) {
      //
      if (_n_idx >= _n_lyr + pn_lyrDff) { // 親階層を取得する場合は pn_lyrDff = 1
        break;
      }
      //
      if (_n_idx == 0) {
        _d_dcts = _d_dcts[_key];
      }
      else {
        _d_dcts = _d_dcts.clds[_key];
      };
    };
    return [_d_dcts, _n_lyr];
  };

  static myCM_get_dct = (pd={ // ld_itemss において fld == val である d_items を取得
    mode: 'items/idx',
    ld_itemss: [{}],
    fld: '',
    val: '',
  }) => {
    let _r = null;
    for (let [_idx, _d_items] of bf.e(pd.ld_itemss)) {
      if (_d_items[pd.fld] == pd.val) {
        _r = (pd.mode == 'idx') ? _idx : _d_items;
        break;
      }
    };
    return _r;
  };

  static myCM_get_keys(pd_vals){
    return Object.keys(pd_vals);
  };

  static myCM_get_len(pa_val){
    if (bf.myCM_chk_type(pa_val, 'dct')) {
      return Object.keys(pa_val).length;
    };
    if (bf.myCM_chk_type(pa_val, 'list')) {
      return pa_val.length;
    };
  };

  static myCM_get_newKey(pa_vals) {

    if (!bf.f(pa_vals)) {
        return 'new';
    };

    if (bf.myCM_chk_type(pa_vals, 'dct')) {
      let _cnt = 1;
      let _newKey = '';
      while (true) {
        if (_cnt == 1) {
          _newKey = 'new';
        }
        else {
          _newKey = 'new{}'.f(_cnt);
        };
        if (pa_vals[_newKey]) {
          _cnt += 1;
        }
        else {
          break;
        };
      };
      return _newKey;
    };

    if (bf.myCM_chk_type(pa_vals, 'list')) {
      let _cnt = 1;
      let _newKey = '';
      while (true) {
        if (_cnt == 1) {
          _newKey = 'new';
        }
        else {
          _newKey = 'new{}'.f(_cnt);
        };
        if (
          bf.myCM_get_dct({
            mode: 'items', 
            ld_itemss: pa_vals, 
            fld:'_KEY', 
            val: _newKey
          })
        ) {
          _cnt += 1;
        }
        else {
          break;
        };
      };
      return _newKey;
    };

  };

  static myCM_get_rnd(pn_max){
    return Math.floor( Math.random() * (bf.n(pn_max) + 1));
  };

  static myCM_get_rng(pn_to, pn_from=1){
    return ((pn_to-pn_from+1) >= 1) ? Array.from(new Array(pn_to-pn_from+1)).map((p_v, p_i) => p_i + pn_from) : [];
  };

  static myCM_get_substr(p_str, pn_from, pn_len){ // pn_from : 0
    return p_str.substr(pn_from, pn_len);
  };

  static myCM_get_type(pa_val) {
    return Object.prototype.toString.call(pa_val).slice(8, -1).toLowerCase();
  };

  static myCM_gnr(pn_len){
    let _s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";        
    var _r = bf.myDT_get_now().replace(/-/g,'').replace(/ /g,'').replace(/:/g,'');
    for(var _i=0; _i<pn_len; _i++){
//      _r += _s[this.myCM_get_rnd(_s.length)];
      _r += _s[this.myCM_get_rnd(_s.length - 1)];
    }
    return _r
  };

  static myCM_pdd(p_nmb, pn_len){ // padding
    return ('0'.repeat(pn_len) + p_nmb).slice(-pn_len);
  };

  static myCM_push(pl_vals1, pl_vals2) {
    Array.prototype.push.apply(pl_vals1, pl_vals2); // 破壊的な配列の結合(新規配列の生成ではなく、一つ目の配列内容を変更)
  };
    
  static myCM_rmv(pl_vals, p_val) { // pl_vals から p_val を除外する
    return pl_vals.filter(_val => _val !== p_val);
  }

  static myCM_split(p_str, p_dlm){
    return p_str.split(p_dlm);
  };

/*
  static myCM_sort = (pd={
    ld_itemss:[{}], 
    ld_sortss:[{fld:'_KEY', dtn:'asc'}], // myRN_call_slc の段階では key などがないことに注意
  }) => { // p_mode: abs/desc, pld_valss: dct が sort 項目を持つこと, pl_keys が複数ある場合に対応要
    if (bf.f(pd.ld_itemss) && bf.f(pd.ld_sortss)) {
      let _ld_itemss = pd.ld_itemss?.slice(); // 元の並び順を壊さない（中の dct は同じものが引き継がれる）
      let _r = _ld_itemss.sort((_a, _b) => {
        let _r2 = 0
        for (let [_idx, _d_sorts] of bf.e(pd.ld_sortss)) {
          let _sign = (_d_sorts.dtn == 'asc') ? 1 : ((_d_sorts.dtn == 'desc') ? -1 : 0); // sort 対象外とする場合を考慮
          if ((_a[_d_sorts.fld] < _b[_d_sorts.fld]) || (!_a[_d_sorts.fld] && _b[_d_sorts.fld])) { // null の場合を考慮
            _r2 = -1 * _sign;
            break;
          } 
          else if ((_a[_d_sorts.fld] > _b[_d_sorts.fld]) || (_a[_d_sorts.fld] && !_b[_d_sorts.fld])) { // null の場合を考慮
            _r2 = _sign;
            break;
          }
        };
        return _r2;
      });
      return _r;
    }
    else {
      return pd.ld_itemss;
    };
  };
*/
  static myCM_sort = (pd={    
    ld_itemss:[{}], 
    ld_sortss:[{fld:'_KEY', dtn:'asc', mode:'str/nmb'}], // myRN_call_slc の段階では key などがないことに注意
  }) => { // p_mode: abs/desc, pld_valss: dct が sort 項目を持つこと, pl_keys が複数ある場合に対応要
    if (bf.f(pd.ld_itemss) && bf.f(pd.ld_sortss)) {
      let _ld_itemss = pd.ld_itemss?.slice(); // 元の並び順を壊さない（中の dct は同じものが引き継がれる）
      let _r = _ld_itemss.sort((_a, _b) => {
        let _r2 = 0
        for (let [_idx, _d_sorts] of bf.e(pd.ld_sortss)) {
          let _mode = (_d_sorts.mode) ? _d_sorts.mode : 'str';
          let _sign = (_d_sorts.dtn == 'asc') ? 1 : ((_d_sorts.dtn == 'desc') ? -1 : 0); // sort 対象外とする場合を考慮
          let _valA = (_mode == 'nmb') ? bf.n(_a[_d_sorts.fld]) : _a[_d_sorts.fld];
          let _valB = (_mode == 'nmb') ? bf.n(_b[_d_sorts.fld]) : _b[_d_sorts.fld];
          if ((_valA < _valB) || (!_valA && _valB)) { // null の場合を考慮
            _r2 = -1 * _sign;
            break;
          } 
          else if ((_valA > _valB) || (_valA && !_valB)) { // null の場合を考慮
            _r2 = _sign;
            break;
          }
        };
        return _r2;
      });
      return _r;
    }
    else {
      return pd.ld_itemss;
    };
  };

  static myCM_copy(pa_val) { // ディープコピー
    if (bf.myCM_chk_type(pa_val, 'dct')) {
      return Object.assign({}, pa_val);
    };
    if (bf.myCM_chk_type(pa_val, 'list')) {
      return pa_val.concat();
    };
  };

  static myCM_upd(pd_vals1, pd_vals2) { // ディープコピーのため、元の配列は上書きされない
    if (bf.f(pd_vals1) && bf.f(pd_vals2)) {
      let _copy = bf.myCM_copy(pd_vals1);
      return Object.assign(_copy, pd_vals2);
    }
    else if (bf.f(pd_vals1) && !bf.f(pd_vals2)) {
      return bf.myCM_copy(pd_vals1);
    }
    else if (!bf.f(pd_vals1) && bf.f(pd_vals2)) {
      return bf.myCM_copy(pd_vals2);
    }
    else {
      return {};
    };
  };

  static myCM_join(pa_vals1, pa_vals2) { // ディープコピーのため、元の配列は上書きされない
    if (!bf.f(pa_vals1) && !bf.f(pa_vals2)) {
      return [];
    }
    else if (bf.f(pa_vals1) && !bf.f(pa_vals2)) {
      return pa_vals1;
    }
    else if (!bf.f(pa_vals1) && bf.f(pa_vals2)) {
      return pa_vals2;
    }
    else if (bf.f(pa_vals1) && bf.f(pa_vals2)) {
      let _copy = bf.myCM_copy(pa_vals1);
      return _copy.concat(pa_vals2);
    }
  };

  static myCM_wait(pn_sec) {
    return new Promise((resolve) => {
      setTimeout(resolve, pn_sec * 1000)
    }); // sleep では動かないもよう
  };

  static myCM_clw(pn_sec, po_fnc) { // clock work
    return new Promise((_resolve) => {
      let _id = setInterval(()=>{
        if (po_fnc()) {
          clearInterval(_id);
          _resolve();
        };
      }, pn_sec * 1000)
    });
  };

  static myCM_cpt(p_mode, pa_val, p_srt_key='hogehoge') { // cpt: crypt, srt: secret 毎回暗号が変わるため、QRには向かない？
    //
    if (!bf.f(pa_val)) {
      return null;
    }
    else {
      //
      if (p_mode == 'e') { // encrypt
        //const _js = require("crypto-js");
        //return _js.AES.encrypt(bf.s({tgt: pa_val}), p_srt_key).toString(); // not sure, but you have to wrap the value with object and stringify them.
        //return CryptoJS.AES.encrypt(bf.s({tgt: pa_val}), p_srt_key).toString(); // not sure, but you have to wrap the value with object and stringify them.
        return bf.s(pa_val);
      };

      if (p_mode == 'd') { // decrypt
        //const _js = require("crypto-js");
        //return bf.j(_js.AES.decrypt(pa_val, p_srt_key).toString(_js.enc.Utf8))?.tgt;
        //return bf.j(CryptoJS.AES.decrypt(pa_val, p_srt_key).toString(CryptoJS.enc.Utf8))?.tgt;
        //return bf.j(CryptoJS.AES.decrypt(pa_val, p_srt_key).toString(CryptoJS.enc.Utf8))?.tgt;
        return bf.j(pa_val);
      };
    };
  };

  static myCM_hash(p_val) {
    //
    if (!bf.f(p_val)) {
      return null;
    }
    else {
      //const _js = require('crypto');
      //return _js.createHash('sha256').update(p_val, 'utf8').digest('hex');
//      return CryptoJS.createHash('sha256').update(p_val, 'utf8').digest('hex');
//      return bf.myCM_cpt('e', p_val, '0z9k2mfGgkaifkg1AfggbFBf0z9k2mfGgkaifkg1AfggbFBf');
      return p_val;
    };
  };

  //////////////////////////////////////////////////////////////////////// for date-time
  static myDT_add_date(p_dtm, pn_day) {
    let _dtm = new Date(p_dtm);
    _dtm.setDate(_dtm.getDate() + pn_day);
    return bf.myDT_cnv('date-fmt', _dtm);
  };

  static myDT_add_mnt(p_dtm, pn_mnt) {
    return moment(p_dtm, 'YYYY-MM-DD HH:mm:ss').add(pn_mnt, 'minutes').format('YYYY-MM-DD HH:mm:ss');
  };

  static myDT_cnv(p_mode, pa_dtm){
    if (p_mode == 'date-fmt') {
      let _dtm = pa_dtm;
      let _opt = {
        year: "numeric", 
        month: "2-digit", 
        day: "2-digit", 
      };
      return _dtm.toLocaleDateString("ja-JP", _opt).replace(/\//g, '-');
    };
    if (p_mode == 'dtm-fmt') {
      let _dtm = pa_dtm;
      let _opt = {
        year: "numeric", 
        month: "2-digit", 
        day: "2-digit", 
        hour: "2-digit", 
        minute: "2-digit", 
        second: "2-digit"
      };
      return _dtm.toLocaleDateString("ja-JP", _opt).replace(/\//g, '-');
    };
    if (p_mode == 'JST-UTC'){
      let _dtm = new Date(pa_dtm);
      return _dtm.toUTCString();
    };
    if (p_mode == '24') { // 24時以上を24時未満に変更
      let _dtm = pa_dtm;
      let _hh = bf.n(_dtm.substr(11,2));
      if (_hh >= 24) {
        _dtm = '{} 23:{}'.f(_dtm.substr(0,10), _dtm.substr(14,5));
        _dtm = bf.myDT_add_mnt(_dtm, (_hh - 23) * 60);
      };
      return _dtm;
    }
  };

  static myDT_flr_mnt(p_dtm, pn_mnt) { // floor
    let _dtm = new Date(p_dtm);
    _dtm.setMinutes(((_dtm.getMinutes() / pn_mnt) | 0) * pn_mnt);
    _dtm.setSeconds(0);
    return bf.myDT_cnv('dtm-fmt', _dtm);
  };

  static myDT_get_dates(p_mth) { // list of the day for the month
    let _ldm = bf.myDT_get_ldm(p_mth);
    let _dtm = bf.myDT_get_fdm(p_mth);
    let _r = [_dtm];
    while (true) {
      _dtm = bf.myDT_add_date(_dtm, 1);
      _r.push(_dtm);
      if (_dtm == _ldm) {
        break;
      };
    };
    return _r;
  };

  static myDT_get_day(p_dtm) { // get week day
    let _dtm = new Date(p_dtm);
    return _dtm.getDay();
  };

  static myDT_get_date(p_date='today', pn_mth=0, pn_day=0, p_mode='-') {

    let _date2 = new Date();

    if (p_date != 'today') {
      _date2 = new Date(p_date);
    }

    if (pn_mth != 0) {
      _date2 = new Date(_date2.getFullYear(), _date2.getMonth() + pn_mth, _date2.getDay());
    };

    if (pn_day != 0) {
      _date2 = new Date(_date2.getFullYear(), _date2.getMonth(), pn_day);
    };

    let _YYYY = _date2.getFullYear();

    let _MM = _date2.getMonth() + 1;
    if (_MM < 10) {_MM = '0' + _MM};

    let _DD = _date2.getDate();
    if (_DD < 10) {_DD = '0' + _DD};

    let _r = '';
    if (p_mode=='-'){
      _r = '{}-{}-{}'.f(_YYYY, _MM, _DD)
    }
    else if (p_mode=='年月日'){
      _r = '{}年{}月{}日'.f(_YYYY, _MM, _DD)
    };
    return _r; 
  };

  static myDT_get_dff(p_mode, p_dtm1, p_dtm2) {
    let _o_dtm1 = new Date(bf.myDT_cnv('24', p_dtm1));
    let _o_dtm2 = new Date(bf.myDT_cnv('24', p_dtm2));
    if (p_mode == 'mnt') { // 分単位
      return (_o_dtm2.getTime() - _o_dtm1.getTime()) / 1000 / 60 | 0; // ミリ秒を変換、端数切り捨て
    };
  };

  static myDT_get_fdm(p_mth) { // fdm : first day of the month
    let _dtm = new Date(p_mth.substr(0,7)+'-01');
    return bf.myDT_cnv('date-fmt', _dtm);
  };

  static myDT_get_ldm(p_mth) { // ldm : last day of the month
    let _dtm = new Date(p_mth.substr(0,7)+'-01');
    _dtm.setMonth(_dtm.getMonth() + 1);
    _dtm.setDate(0);
    return bf.myDT_cnv('date-fmt', _dtm);
  };

  static myDT_get_mth() {
    let _now = new Date();
    let _MM = _now.getMonth()+1;
    if (_MM < 10) {_MM = '0' + _MM};
    return _MM;
  };

  static myDT_get_year() {
    let _now = new Date();
    let _YYYY = _now.getFullYear();
    return _YYYY;
  };

  static myDT_get_now() {
    let _dtm = new Date();
    return bf.myDT_cnv('dtm-fmt', _dtm);
  };

  static myFL_ept(pd={ // export file, only for web
    fileName: '',
    val: '',
  }) {
    let _blob = new Blob([pd.val], {type: "text/plain;charset=utf-8"});
    FileSaver.saveAs(_blob, pd.fileName);
  };

/*
  static myFL_read(pd={
    mode: 'text/csv',
    o_file: null,
  }) {
    return new Promise( _o_end1 => {
      if (pd.mode == 'text') {
        let reader = new FileReader();
        reader.readAsText(pd.o_file);
        reader.onload = () => {
          _o_end1(reader.result);
        };
      }
      else if (pd.mode == 'csv') {
        let reader = new FileReader();
        reader.readAsText(pd.o_file);
        reader.onload = () => {

          Papa.parse(reader.result, {
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
            delimiter: ',',
            linebreak: '\n',
            complete: _d_rs => {
//              _d_rs.ld_valss = _d_rs.data; // 命名規則を合わせるための言い換え
              _d_rs.ld_iss = _d_rs.data; // 命名規則を合わせるための言い換え
              _d_rs.data = null; // 命名規則を合わせるための言い換え
bf.l('820: {}'.f(_d_rs))
              _o_end1(_d_rs);
            },
          });
        };
      }
      else {
        alert('incorrect mode at myFL_read.');
      };
    });
  };
*/

/*
  static myFL_read(pd={
    mode: 'text/csv',
    o_file: null,
  }) {
    return new Promise( _o_end1 => {
      if (pd.mode == 'text') {
        let reader = new FileReader();
//        reader.readAsText(pd.o_file);
        reader.readAsArrayBuffer(pd.o_file);
        reader.onload = (_evt) => {
          const _ary = new Unit8Array(_evt.target.result);
          const _ecd = Encoding.detect(_ary);
          const _ucd = Encoding.convert(_ary, {
            to: 'unicode',
            from: _ecd,
            type: 'string'
          });
          _o_end1(_ucd);
        };
      }
      else if (pd.mode == 'csv') {
        let reader = new FileReader();

        reader.readAsArrayBuffer(pd.o_file);
        reader.onload = (_evt) => {
          const _ary = new Unit8Array(_evt.target.result);
          const _ecd = Encoding.detect(_ary);
bf.l('864: {}'.f(_ecd))
          const _ucd = Encoding.convert(_ary, {
            to: 'unicode',
            from: _ecd,
            type: 'string'
          });
          Papa.parse(_ucd, {
            header: true,
            dynamicTyping: true,
            skipEmptyLines: true,
            delimiter: ',',
            linebreak: '\n',
            complete: _d_rs => {
              _d_rs.ld_iss = _d_rs.data; // 命名規則を合わせるための言い換え
              _d_rs.data = null; // 命名規則を合わせるための言い換え
bf.l('878: {}'.f(_d_rs))
              _o_end1(_d_rs);
            },
          });
          _o_end1(reader.result);
        };
      }
      else {
        alert('incorrect mode at myFL_read.');
      };
    });
  };
*/
  static myFL_read(pd={
    mode: 'text/csv',
    o_file: null,
  }) {
    return new Promise( _o_end1 => {
      if (pd.mode == 'text') {
        let reader = new FileReader();
        reader.readAsBinaryString(pd.o_file);
        reader.onload = (_evt) => {
          const _ary = bf.myCM_cnv('str-ary', _evt.target.result);
          const _ecd = Encoding.detect(_ary);
          const _ucd = Encoding.convert(_ary, {
            to: 'unicode',
            from: _ecd,
            type: 'string'
          });
          _o_end1(_ucd);
        };
      }
      else if (pd.mode == 'csv') {
        let reader = new FileReader();
        reader.readAsBinaryString(pd.o_file);
        reader.onload = (_evt) => {
          const _ary = bf.myCM_cnv('str-ary', _evt.target.result);
          const _ecd = Encoding.detect(_ary);
          const _ucd = Encoding.convert(_ary, {
            to: 'unicode',
            from: _ecd,
            type: 'string'
          });
//bf.l('948: {}'.f(_ucd))
          bf.myCM_cnvCsvToJson(_ucd)
          .then( _d_rs => {
            _o_end1(_d_rs);
          })
        };
      }
      else {
        alert('incorrect mode at myFL_read.');
      };
    });
  };

}
